// The loading indicator (#ind_container, app/Indicator.tsx) shows while at least one asynchronous action
// the player waits for is running (owner 2026-10-16: like the legacy indicator, for the start-up, a card
// or theme change, the login, the stats, the contact form). One counter for all of them; background work
// the player does not wait for (the save-win POST, the silent login) is not counted.
// Debounce (owner 2026-10-16): once up, the indicator stays HIDE_DELAY_MS after the last action ends, so
// it does not flash for a quick action and stays up between actions that follow each other. The start-up
// is the exception: it hides at once, so it starts to leave before the first deal (legacy order, BOOT-005).
import { uiStore } from '../store/uiStore';

export const HIDE_DELAY_MS = 1000; // 1.5 s until 2026-10-29 (owner: "czasem za długo się pokazuje", half a second less)

// the start-up preload counts as the first action: uiStore starts with `loading: true`
let count = 1;
let hideTimer: ReturnType<typeof setTimeout> | undefined;

function setLoading(loading: boolean) {
  if (uiStore().getState().loading !== loading) uiStore().set({ loading });
}

function publish(now = false) {
  clearTimeout(hideTimer);
  hideTimer = undefined;
  if (count > 0) setLoading(true);
  else if (now) setLoading(false);
  else hideTimer = setTimeout(() => setLoading(false), HIDE_DELAY_MS);
}

export function busyBegin(): () => void {
  count += 1;
  publish();
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    count = Math.max(0, count - 1);
    publish();
  };
}

/** Runs `work` with the indicator shown. */
export async function withIndicator<T>(work: () => Promise<T>): Promise<T> {
  const end = busyBegin();
  try {
    return await work();
  } finally {
    end();
  }
}

/** The start-up preload is done (app-entry.tsx). */
export function startupDone(): void {
  count = Math.max(0, count - 1);
  publish(true);
}
